import React from "react";
import style from "./index.module.scss";
import { ExerciseStatus } from "../../../../../service/exercise";
import useVerifyExercise from "../../../../../utils/useVerifyExercise";
import { message } from "antd";
import { errorMessage } from "../../../../../service/service";

interface ListStaticsProps {
    exerciseId: number;
    exerciseAllCount: number;
    noJudgeCount: number;
    judgeCount: number;
    noJoinInExerciseCount: number;
    gotoDetail: (exerciseId: number, params?: StringMap) => void;
}

export default function ListStatics({
    exerciseId,
    exerciseAllCount,
    noJudgeCount,
    judgeCount,
    noJoinInExerciseCount,
    gotoDetail
}: ListStaticsProps) {
    const { onVerify } = useVerifyExercise();
    const verifyStatusList = [
        {
            verifyStatus: ExerciseStatus.del,
            noticeContent: "练习活动已删除，请刷新页面"
        }
    ];

    async function onClick(fn: () => void) {
        try {
            const executeContinue = await onVerify(
                exerciseId,
                verifyStatusList
            );
            if (executeContinue) {
                fn();
            }
        } catch (e) {
            message.error(errorMessage(e));
        }
    }

    return (
        <div className={style.root}>
            <div
                className={style.item}
                onClick={() =>
                    onClick(() => gotoDetail(exerciseId, { status: "all" }))
                }>
                {exerciseAllCount}
                <br />
                <span>课程人数</span>
            </div>
            <div
                className={style.item}
                onClick={() =>
                    onClick(() => gotoDetail(exerciseId, { status: "noJudge" }))
                }>
                {noJudgeCount}
                <br />
                <span>待批阅</span>
            </div>
            <div
                className={style.item}
                onClick={() =>
                    onClick(() =>
                        gotoDetail(exerciseId, { status: "judgeCount" })
                    )
                }>
                {judgeCount}
                <br />
                <span>已批阅</span>
            </div>
            <div
                className={style.item}
                onClick={() =>
                    onClick(() =>
                        gotoDetail(exerciseId, { status: "noJoinIn" })
                    )
                }>
                {noJoinInExerciseCount}
                <br />
                <span>未参与</span>
            </div>
        </div>
    );
}

ListStatics.defaultProps = {
    exerciseAllCount: 0,
    noJudgeCount: 0,
    judgeCount: 0,
    noJoinInExerciseCount: 0
};
